var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityWorkshopsFocused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab01_filled 1",
    clipPath: "url(#clip0_794_22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9 18.1332C6.9 14.2278 9.9912 11.04 13.8 11.04H55.2C59.0088 11.04 62.1 14.2278 62.1 18.1332V46.5198H55.2V18.1332H13.8V46.5198H6.9V18.1332ZM0 52.2054C0 51.0324 0.9246 50.0802 2.07 50.0802H66.93C68.0754 50.0802 69 51.0324 69 52.2054C69 56.9112 65.2878 60.72 60.72 60.72H8.28C3.7122 60.72 0 56.9112 0 52.2054ZM30.291 30.6636L26.9514 34.1136L30.291 37.5498C31.3122 38.5848 31.3122 40.2684 30.291 41.3034C29.2836 42.3384 27.6414 42.3522 26.634 41.3034L21.459 35.9766C20.4516 34.9416 20.4516 33.258 21.459 32.223L26.634 26.8962C27.6552 25.8612 29.2974 25.8612 30.291 26.8962C31.2984 27.945 31.3122 29.6286 30.291 30.6636ZM42.366 26.8962L47.541 32.223C48.5622 33.2718 48.5622 34.9554 47.541 35.9766L42.366 41.3034C41.3586 42.3522 39.7164 42.3522 38.709 41.3034C37.7154 40.2684 37.7016 38.571 38.709 37.5498L42.0624 34.1136L38.709 30.6636C37.7016 29.6286 37.7016 27.945 38.709 26.91C39.7302 25.875 41.3724 25.875 42.366 26.8962Z",
    fill: "#9FD1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityWorkshopsFocused);
export default __webpack_public_path__ + "static/media/activity-workshops-focused.56cb403317a90a9ae84b9c6dc46f4d5b.svg";
export { ForwardRef as ReactComponent };